import { MultiValuedListMoreItem } from '../../../MultiValuedList'
import { EmailTableRowActivitiesContent } from '../EmailTableRowActivitiesContent'

import * as styles from './EmailTableRowActivitiesMoreItem.module.css'

function EmailTableRowActivitiesMoreItem({
  className = styles.EmailTableRowActivitiesMoreItem,
  label,
  ...itemProps
}) {
  return (
    <MultiValuedListMoreItem {...itemProps} className={className}>
      <EmailTableRowActivitiesContent label={label} />
    </MultiValuedListMoreItem>
  )
}

export default EmailTableRowActivitiesMoreItem
